import { Box, Theme, useTheme } from '@mui/material'
import { ILLUSTRATION_WIDTH, SPACE } from '../styles/layout'

const ZIcon = (props: any) => {
  const { style, Icon, ...rest } = props
  const theme = useTheme<Theme>()

  return (
    // Responsive default width lives on the wrapper so a caller can still pin
    // an exact size via `style` (e.g. the 1.5rem back chevron in Header):
    // an inline style on the svg always wins over this rule.
    // height: auto is essential: the SVG files carry a fixed height attribute
    // (~127px), so without it the drawing stays that tall whatever the width.
    <Box sx={{ '& > svg': { width: ILLUSTRATION_WIDTH, height: 'auto' } }}>
      <Icon
        fill={theme.palette.primary.main}
        style={{
          marginBottom: SPACE.xl,
          ...style,
        }}
        {...rest}
      />
    </Box>
  )
}

export default ZIcon
